<script>
  import { getApiUrl } from '../api';
  import { authFetch } from '../authService';

  let googleMapsLink = '';
  let name = '';
  let address = '';
  let country = 'HK';
  let selectedCategories = [];
  let allCategories = ["Dining", "Shopping", "Services", "Entertainment", "Travel"]; 
  
  let generatedCode = '';
  let isLoading = false;
  let error = '';

  async function handleExtract() {
    if (!googleMapsLink) return;
    isLoading = true;
    try {
      const res = await authFetch(getApiUrl('/admin/premises/extract'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url: googleMapsLink })
      });
      const data = await res.json();
      // Pre-fill form
      name = data.name || '';
      address = data.address || '';
      country = data.country || 'HK';
      if(data.categories) selectedCategories = data.categories;
    } catch(e) {
      console.error(e);
      error = "Failed to extract data. Please enter manually.";
    } finally {
      isLoading = false;
    }
  }

  async function handleSave() {
    isLoading = true;
    error = '';

    // --- VALIDATION LOGIC ---
    if (!name.trim() || !country.trim() || !address.trim()) {
        error = "Store Name, Country Code, and Address are required.";
        isLoading = false;
        return;
    }

    const payload = {
        name, address, googleMapsLink, country, categories: selectedCategories
    };
    
    try {
        const res = await authFetch(getApiUrl('/admin/premises/ghost'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        
        if(!res.ok) throw new Error("Failed to create.");
        
        const data = await res.json();
        generatedCode = data.invitationCode; 
        
    } catch(e) {
        error = e.message;
    } finally {
        isLoading = false;
    }
  }
</script>

<div class="admin-container">
    <h2>Create Invitation</h2>
    {#if !generatedCode}
        <div class="input-group">
            <label for="maps-link">Google Maps Link (Optional)</label>
            <div class="row-stack">
                <input type="text" id="maps-link" bind:value={googleMapsLink} placeholder="Paste URL here..." />
                <button class="action-btn" on:click={handleExtract} disabled={isLoading}>
                    {isLoading ? 'Loading...' : 'Auto-Fill'}
                </button>
            </div>
        </div>
        
        <div class="form-grid">
            <div class="input-group">
                <label for="store-name">Store Name *</label>
                <input type="text" id="store-name" bind:value={name} required />
            </div>
            <div class="input-group">
                <label for="country-code">Country Code *</label>
                <input type="text" id="country-code" bind:value={country} required />
            </div>
            <div class="input-group full">
                <label for="address">Address *</label>
                <input type="text" id="address" bind:value={address} required />
            </div>
            <div class="input-group full">
                <label>Categories</label>
                <div class="cats">
                    {#each allCategories as cat}
                        <label class="chk">
                            <input type="checkbox" value={cat} bind:group={selectedCategories}> 
                            {cat}
                        </label>
                    {/each}
                </div>
            </div>
        </div>

        <button class="save-btn" on:click={handleSave} disabled={isLoading}>
            {isLoading ? 'Saving...' : 'Save & Generate Code'}
        </button>
        
        {#if error}
            <p class="error">{error}</p>
        {/if}
    {:else}
        <div class="success-card">
            <h3>Premise Created!</h3>
            <p>Write this code on the invitation card for <strong>{name}</strong>:</p>
            <div class="code">{generatedCode}</div>
            <button class="reset-btn" on:click={() => { generatedCode = ''; name=''; address=''; googleMapsLink=''; }}>Create Another</button>
        </div>
    {/if}
</div>

<style>
    .admin-container { 
        max-width: 600px; 
        margin: 2rem auto; 
        padding: 1.5rem; 
        background: white; 
        border-radius: 8px; 
        box-shadow: 0 2px 10px rgba(0,0,0,0.1); 
    }

    h2 { margin-top: 0; }

    /* Input Group Styling */
    .input-group {
        margin-bottom: 1rem;
        text-align: left;
    }
    
    label {
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 500;
    }

    input[type="text"] { 
        width: 100%; 
        padding: 0.75rem; 
        box-sizing: border-box; 
        border: 1px solid #ccc; 
        border-radius: 4px;
        font-size: 1rem;
    }

    /* Mobile-First Stack Layout for Row */
    .row-stack { 
        display: flex; 
        flex-direction: column; 
        gap: 10px; 
    }

    /* Grid Layout */
    .form-grid { 
        display: grid; 
        grid-template-columns: 1fr; /* Default 1 column for mobile */
        gap: 1rem; 
        margin: 1rem 0; 
    }

    /* Category Checkboxes */
    .cats { 
        display: flex; 
        flex-wrap: wrap; 
        gap: 1rem; 
    }
    .chk {
        display: flex;
        align-items: center;
        gap: 0.3rem;
        background: #f8f9fa;
        padding: 0.5rem 0.8rem;
        border-radius: 4px;
        cursor: pointer;
    }

    /* Buttons */
    button {
        font-size: 1rem;
        cursor: pointer;
        border: none;
        border-radius: 4px;
        padding: 0.75rem 1rem;
    }

    .action-btn {
        background-color: #6c757d;
        color: white;
        width: 100%; /* Full width on mobile */
    }

    .save-btn { 
        width: 100%; 
        background-color: #28a745; 
        color: white; 
        font-size: 1.1rem; 
        margin-top: 1rem;
    }

    .reset-btn {
        background-color: #007bff;
        color: white;
        padding: 0.75rem 2rem;
    }

    /* Success Card */
    .success-card { 
        text-align: center; 
        background: #e8f5e9; 
        padding: 2rem; 
        border-radius: 8px; 
    }
    .code { 
        font-size: 3rem; 
        font-weight: bold; 
        letter-spacing: 5px; 
        margin: 1rem 0; 
        color: #2e7d32; 
        word-break: break-all; /* Prevent overflow on small screens */
    }
    
    .error { color: red; text-align: center; font-weight: bold; margin-top: 1rem;}

    /* Tablet and Desktop Styles */
    @media (min-width: 600px) {
        .form-grid { 
            grid-template-columns: 1fr 1fr; /* 2 columns on larger screens */
        }
        .full { 
            grid-column: span 2; 
        }
        .row-stack {
            flex-direction: row; /* Side by side on larger screens */
        }
        .action-btn {
            width: auto; /* Auto width on larger screens */
            white-space: nowrap;
        }
    }
</style>